import React from "react";
import TranslationContext from "../components/TranslationContext";
import { Login } from "../_core/auth/Login";
import PageFooter from "../components/PageBody/PageFooter";
import { makeStyles } from "@material-ui/core";
import { Translations } from "../_core/translations/Translations";
import SetRandomScreen from "../common/SetRandomScreen";
import { BodyClassEnum } from "../common/Enums";
import Header from "../components/PageBody/Parts/Header";

const useStyles = makeStyles({
  content: {
    minHeight: 571,
  },
  explanation: {
    alignItems: "flex-start",
    flexDirection: "column",
    minWidth: 0,
    width: "100%",
  },
  square: {
    listStyleType: "square",
    margin: 0,
    paddingLeft: 24,
  },
  listItem: {
    marginBottom: 8,
    overflowWrap: "anywhere",
  },
  fallbackLink: {
    maxWidth: "100%",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
  },
});

/**
 *
 * @returns A component that is rendered when the URL of the Login page doesn't have the correct format
 */
interface IFallbackLandingPageProps {
  fallbackUrl?: string;
}

const FallbackLandingPage: React.FunctionComponent<IFallbackLandingPageProps> = (
  props
) => {
  const translations: Translations = React.useContext(TranslationContext);
  const url: string = window.location.host;
  const product = Login.defaultProductName;
  const descriptionIncorrectAccess: string =
    translations.descriptionIncorrectAccess;
  const urlSuggestion: string =
    translations.descriptionAccessSuggestion1.replace("{url}", url);
  const suggestions: string[] = [
    urlSuggestion,
    translations.descriptionAccessSuggestion2,
    translations.descriptionAccessSuggestion3,
  ];

  const classes = useStyles();

  return (
    <div
      id="content-container"
      style={{ width: "min(560px, calc(100vw - 48px))" }}
    >
      <section className={`content multi-input-field ${classes.content}`}>
        <Header
          headerResourceKey="captionLoginWelcome"
          replacePlaceHolder={(source) => {
            return source.replace("{product}", product);
          }}
        />
        <section className={`explanation ${classes.explanation}`}>
          <p>{descriptionIncorrectAccess}</p>
          <ul className={classes.square}>
            {suggestions.map((suggestion, index) => {
              return (
                <li className={classes.listItem} key={index}>
                  {suggestion}
                </li>
              );
            })}
            {props.fallbackUrl && (
              <li className={classes.listItem}>
                Go to{" "}
                <a className={classes.fallbackLink} href={props.fallbackUrl}>
                  {props.fallbackUrl}
                </a>
              </li>
            )}
          </ul>
        </section>
        <PageFooter />
      </section>
    </div>
  );
};

export default SetRandomScreen(
  FallbackLandingPage,
  BodyClassEnum.FallbackLandingPage
);
